import { render, staticRenderFns } from "./keCheng.vue?vue&type=template&id=627db992&scoped=true"
import script from "./keCheng.vue?vue&type=script&lang=js"
export * from "./keCheng.vue?vue&type=script&lang=js"
import style0 from "./keCheng.vue?vue&type=style&index=0&id=627db992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627db992",
  null
  
)

export default component.exports